import { login, logout, getInfo, getUserWithCorpId, editpwd, getUser, getLogo, setLogo, getPass, ssoLogin } from '@/api/user'
import {
	getToken,
	setToken,
	removeToken,
	setTenant,
	removeTenant,
	setCustEffId
} from '@/utils/auth'
import router, { resetRouter } from '@/router'

const state = {
	token: getToken(),
	name: '',
	avatar: '',
	hasRoles: false,
	loginLogoUrl: '',
	logoUrl: '',
	userInfo: {},
	permissions: [],
	menuTree: []
}

const mutations = {
	SET_TOKEN: (state, token) => {
		state.token = token
	},
	SET_NAME: (state, name) => {
		state.name = name
	},
	SET_AVATAR: (state, avatar) => {
		state.avatar = avatar
	},
	SET_LOGO: (state, url) => {
		state.logoUrl = url
	},
	SET_USERINFO: (state, preload) => {
		state.userInfo = preload
		state.hasRoles = !!preload.roles.length
	},
	SET_MENUTREE: (state, data) => {
		state.menuTree = data || []
	},
	SET_PERMISSIONS: (state, permissions) => {
		state.permissions = permissions
	}
}

const actions = {
	getUserWithCorpId ({ commit }, data) {
		return new Promise((resolve, reject) => {
			getUserWithCorpId(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	// 解密
	getPass ({ commit }, data) {
		return new Promise((resolve, reject) => {
			getPass(data)
				.then(res => {
					console.log(res, 9875622555)
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	// logo获取
	getLogo ({ state, commit }, data) {
		console.log(2222, state)
		if (state.userInfo && state.userInfo.userId == '0') return
		return new Promise((resolve, reject) => {
			getLogo(data)
				.then(res => {
					commit('SET_LOGO', res)
					console.log(res, state)
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	// logo设置
	setLogo ({ commit }, data) {
		return new Promise((resolve, reject) => {
			setLogo(data)
				.then(res => {
					commit('SET_LOGO', data)
					resolve(data)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	// user login
	login ({ commit }, userInfo) {
		// var content ='{"username": "admin","password": "aKu1/348LvKp0rsVC06eCA==","scope": "server","grant_type": "password","role": "manager"}';
		// var content =
		//   '{"username": "' +
		//   user.username +
		//   '","password": "' +
		//   user.password +
		//   '","scope": "server","grant_type": "password","role": "manager"}';
		return new Promise((resolve, reject) => {
			login(userInfo)
				.then(response => {
					// const { data } = response
					console.log(response, 99999)
					// if (response.code != null) {
					// } else {
					// commit("SET_TOKEN", response.access_token);
					commit('SET_TOKEN', response.x_token)
					commit('SET_NAME', response.username)
					// setToken(response.access_token);
					setToken(response.x_token)
					if (response.merchantId) {
						setTenant(response.merchantId)
					}
					setCustEffId(response.custEffId)
					localStorage.setItem('custEffId', response.custEffId)
					// }
					resolve(response)
				})
				.catch(error => {
					console.log(error)
					reject(error)
				})
		})
	},
	ssoLogin ({ commit }, userInfo) {
		return new Promise((resolve, reject) => {
			ssoLogin(userInfo)
				.then(response => {
					commit('SET_TOKEN', response.x_token)
					commit('SET_NAME', response.username)
					// setToken(response.access_token);
					setToken(response.x_token)
					if (response.merchantId) {
						setTenant(response.merchantId)
					}
					setCustEffId(response.custEffId)
					localStorage.setItem('custEffId', response.custEffId)
					// }
					resolve(response)
				})
				.catch(error => {
					console.log(error)
					router.push('/login')
					reject(error, 99998888)
				})
		})
	},
	// get user info
	getInfo ({ commit, state }) {
		return new Promise((resolve, reject) => {
			getInfo(state.token)
				.then(response => {
					const { username, avatar, menuTree, permissionList } = response
					commit('SET_USERINFO', response)
					commit('SET_MENUTREE', menuTree)
					commit('SET_NAME', username)
					commit('SET_AVATAR', avatar)
					commit('SET_PERMISSIONS', permissionList)
					resolve([])
				})
				.catch(error => {
					commit('SET_TOKEN', '')
					commit('SET_ROLES', '')
					removeToken()
					// resetRouter()
					removeTenant()
					// reset visited views and cached views
					// to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
					// dispatch('tagsView/delAllViews', null, { root: true })

					reject(error)
				})
		})
	},

	// user logout
	logout ({ commit, state, dispatch }) {
		return new Promise((resolve, reject) => {
			logout(state.token)
				.then(response => {
					// const {data} = response;
					// const {code} = response;
					// alert(data+code)
					commit('SET_TOKEN', '')
					commit('SET_MENUTREE', [])
					removeToken()
					resetRouter()
					removeTenant()
					// reset visited views and cached views
					// to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
					dispatch('tagsView/delAllViews', null, { root: true })

					resolve()
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	// remove token
	resetToken ({ commit }) {
		return new Promise(resolve => {
			commit('SET_TOKEN', '')
			commit('SET_MENUTREE', [])
			removeToken()
			removeTenant()
			resolve()
		})
	},

	// dynamically modify permissions
	changeRoles ({ commit, dispatch }, role) {
		// eslint-disable-next-line no-async-promise-executor
		return new Promise(async resolve => {
			const token = role + '-token'

			commit('SET_TOKEN', token)
			setToken(token)

			const { roles } = await dispatch('getInfo')

			resetRouter()

			// generate accessible routes map based on roles
			const accessRoutes = await dispatch('permission/generateRoutes', roles, {
				root: true
			})

			// dynamically add accessible routes
			router.addRoutes(accessRoutes)

			// reset visited views and cached views
			dispatch('tagsView/delAllViews', null, { root: true })

			resolve()
		})
	},

	editpwd ({}, data) {
		return new Promise((resolve, reject) => {
			editpwd(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	getUser ({}, data) {
		return new Promise((resolve, reject) => {
			getUser(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
